import type { IconName } from '@freelancer/ui/icon';

export enum SocialMediaText {
  facebook = 'Facebook',
  twitter = 'Twitter',
  linkedin = 'LinkedIn',
  reddit = 'Reddit',
  telegram = 'Telegram',
  messenger = 'Messenger',
}

export interface SocialMediaInfo {
  iconName: IconName;
  className: string;
  text: string;
  labelText: string;
  /**
   * Copy-to-clipboard buttons have no external share URL — they copy the
   * current link instead of navigating away.
   */
  isCopyLink?: boolean;
}

export const LIST_OF_SOCIAL_MEDIA_INFO: {
  [key in ShareIcons]: SocialMediaInfo;
} = {
  facebook: {
    iconName: 'flFacebookFilled',
    className: '--facebook',
    text: 'Facebook',
    labelText: $localize`Share on Facebook`,
  },
  twitter: {
    iconName: 'flX',
    className: '--twitter',
    text: 'X',
    labelText: $localize`Share on X`,
  },
  linkedin: {
    iconName: 'flLinkedinFilled',
    className: '--linkedin',
    text: 'LinkedIn',
    labelText: $localize`Share on LinkedIn`,
  },
  reddit: {
    iconName: 'flReddit',
    className: '--reddit',
    text: 'Reddit',
    labelText: $localize`Share on Reddit`,
  },
  telegram: {
    iconName: 'flTelegram',
    className: '--telegram',
    text: 'Telegram',
    labelText: $localize`Share on Telegram`,
  },
  messenger: {
    iconName: 'flFacebookMessenger',
    className: '--messenger',
    text: 'Messenger',
    labelText: $localize`Share on Messenger`,
  },
  copyLink: {
    iconName: 'flLink',
    className: '--copyLink',
    text: $localize`Copy link`,
    labelText: $localize`Copy link`,
    isCopyLink: true,
  },
};

export type ShareButtonSizes = 'mid' | 'large';

export type ShareIcons =
  | 'facebook'
  | 'twitter'
  | 'linkedin'
  | 'reddit'
  | 'telegram'
  | 'messenger'
  | 'copyLink';

export type ShareButtonSpacing =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'initial'
  | 'inherit';
